export default {
    Metadata: {
        Name: "StartsWith",
        Description: "Returns true if the base string starts with the specified string.",
        Syntax: "StartsWith(string, find_string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(fullString, startString) {
        if (fullString == null || startString == null) {
            return false;
        }

        if (typeof fullString != 'string') {
            fullString = fullString.toString();
        }

        return fullString.startsWith(startString);
        //return fullString.indexOf(startString) == 0;
    },
};

